import { render, staticRenderFns } from "./ContactFreelanceForm.vue?vue&type=template&id=04e055d2"
import script from "./ContactFreelanceForm.vue?vue&type=script&lang=ts"
export * from "./ContactFreelanceForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports